<template>
  <div>
    <b-modal
      id="drivers-bulk-block"
      title="Block Bulks"
      ok-variant="success"
      ok-title="Save"
      ok-only
      :ok-disabled="submitting"
      :no-close-on-backdrop="submitting"
      :no-close-on-esc="submitting"
      :hide-header-close="submitting"
      @ok.prevent="submit"
    >
      <validation-observer ref="transactionBulksRef">
        <b-form>
          <validation-provider
            #default="{ errors }"
            name="File"
            rules="required"
          >
            <b-form-group
              label="File"
              label-for="bulk-transaction-file"
            >
              <b-form-file
                id="bulk-transaction-file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                :disabled="submitting"
                @change="setFile"
              />
              <span class="text-danger">
                {{ errors[0] }}
              </span>
            </b-form-group>
          </validation-provider>
        </b-form>
        <div class="d-flex justify-content-between align-items-center">
          <template v-if="submitting">
            <span>Please be patient...</span>
            <b-spinner />
          </template>
        </div>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import axios from 'axios'
import {
  BModal, BFormGroup, BFormFile, BForm, BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import axiosIns from '@/libs/axios'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BForm,
    BFormGroup,
    BModal,
    ValidationObserver,
    ValidationProvider,
    BFormFile,
    BSpinner,
  },
  setup(_, ctx) {
    const user = JSON.parse(localStorage.getItem('userData'))
    const selectedFile = ref()
    const submitting = ref(false)
    const submit = async () => {
      submitting.value = true
      try {
        const preSignedRes = await axiosIns.get('/signed-urls/bucket', {
          params: {
            nestedFolderName: 'block_driver',
            isPublic: true,
          },
        })
        const { url, key } = preSignedRes.data.data
        await axios.put(url, selectedFile.value, {
          headers: {
            'Content-Type': selectedFile.value.type,
          },
        })
        await axiosIns.post('/drivers/bulk-block-driver', {
          Key: key,
          inactivationReason: 'ee04031e-af07-47ae-b79a-32d595627d09',
          createdBy: user.email,
        })
        ctx.root.$bvModal.hide('drivers-bulk-block')
        successNotification('Operation Succeeded')
      } catch (er) {
        errorNotification('An error Occured')
      } finally {
        submitting.value = false
      }
    }

    const setFile = async ev => {
      const [file] = ev.target.files
      selectedFile.value = file
    }
    return {
      submit,
      submitting,
      setFile,
    }
  },
}
</script>

  <style>

  </style>
